<div class="ds-tooltip-wrap" (animationend)="animationEnd.emit()" [class.open]="openAnimation" [class.close]="closeAnimation" #tooltip [ngStyle]="tooltipStyle">
  <div class="ds-tooltip ds-tooltip-{{color}} ds-tooltip-{{size}} ds-tooltip-{{font}}" [ngClass]="{'with-shadow': withShadow, 'for-demo': demoVideo}"
       *ngIf="template">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
  </div>
  <div *ngIf="!template && content" class="ds-tooltip ds-tooltip-{{color}} ds-tooltip-{{size}} ds-tooltip-{{font}}"
       [ngClass]="{'with-shadow': withShadow}" [innerHTML]="content | safeHtml">
  </div>
</div>
